jQuery(document).ready(function($) {
  $('#FacetsWrapperDesktop details').each(function() {
    $(this).attr('open', true);
  });
  
  $('.gn-user-guide-inner ul li a').click(function(e) {
    e.preventDefault();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }
    var selectedFilter = $(this).attr('data-filter');

    switch(selectedFilter) {
      case 'solution-stress':
        $('#Facet-1-template--17449810100423__product-grid input[value="Stress"]').trigger('click');
        break;
        
      case 'solution-sleep':
        $('#Facet-1-template--17449810100423__product-grid input[value="Sleep"]').trigger('click');
        break;
        
      case 'solution-muscle-joint':
        $('#Facet-1-template--17449810100423__product-grid input[value="Muscle & Joint"]').trigger('click');
        break;
        
      case 'solution-entourage':
        $('#Facet-1-template--17449810100423__product-grid input[value="Entourage"]').trigger('click');
        break;
        
      case 'form-gummies':
        $('#Facet-2-template--17449810100423__product-grid input[value="Gummies"]').trigger('click');
        break;
        
      case 'form-oils':
        $('#Facet-2-template--17449810100423__product-grid input[value="Oils"]').trigger('click');
        break;
        
      case 'form-topicals':
        $('#Facet-2-template--17449810100423__product-grid input[value="Topicals"]').trigger('click');
        break;
        
      case 'form-soft-gels':
        $('#Facet-2-template--17449810100423__product-grid input[value="Soft Gels"]').trigger('click');
        break;
        
      case 'strength-light':
        $('#Facet-3-template--17449810100423__product-grid input[value="Light"]').trigger('click');
        break;
        
      case 'strength-medium':
        $('#Facet-3-template--17449810100423__product-grid input[value="Medium"]').trigger('click');
        break;
        
      case 'strength-heavy':
        $('#Facet-3-template--17449810100423__product-grid input[value="Heavy"]').trigger('click');
        break;
    }

    $('html, body').animate({
        scrollTop: $("ul#product-grid").offset().top
    }, 500);
  });
});